(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["quiz-section"]) return;
  try {
    
function appQuizFit(p, answers) {
  var room = {compact:0, bed:1, open:2};
  var days = Number(p.max);
  var spaceGap = p.space in room ? Math.max(0, room[p.space] - room[answers.space]) : 3;
  var seasonGap = days > 0 ? Math.max(0, days - Number(answers.season)) : 60;
  var seedMismatch = answers.seed_type !== 'any' && p.seed_type !== answers.seed_type;
  var useMismatch = !Array.isArray(p.uses) || p.uses.indexOf(answers.use) === -1;
  var borerMismatch = answers.borer === 'high' && !p.resistant;
  return {spaceGap:spaceGap, seasonGap:seasonGap, seedMismatch:seedMismatch, useMismatch:useMismatch, borerMismatch:borerMismatch,
    physical:spaceGap * 160 + seasonGap * 3,
    preference:(seedMismatch ? 8 : 0) + (useMismatch ? 6 : 0) + (borerMismatch ? 12 : 0)};
}
function appRankQuizProducts(products, answers) {
  var candidates = products.filter(function(p) { return p && p.handle && p.url; });
  var available = candidates.filter(function(p) { return p.available; });
  if (available.length) candidates = available;
  return candidates.map(function(p, index) { return {product:p, fit:appQuizFit(p, answers), index:index}; })
    .sort(function(a,b) { return a.fit.physical - b.fit.physical || a.fit.preference - b.fit.preference || a.index - b.index; })
    .slice(0,3).map(function(item) { return item.product; });
}
(function() {
  var root=document.getElementById('app-variety-quiz'); if(!root)return;
  var form=root.querySelector('form'), steps=Array.from(root.querySelectorAll('fieldset'));
  var products=JSON.parse(root.querySelector('#app-quiz-products').textContent);
  var labels=JSON.parse(root.querySelector('#app-quiz-labels').textContent);
  if (!products.length) products=[{handle:'butterscotch-type',title:labels.fallback_title,url:'/collections/small-space-pumpkins',min:100,max:100,available:false,space:'compact',seed_type:'f1',resistant:true,uses:['roast'],fallback:true}];
  var next=root.querySelector('#app-quiz-next'), back=root.querySelector('#app-quiz-back');
  var progress=root.querySelector('#app-quiz-progress'), error=root.querySelector('#app-quiz-error');
  var results=root.querySelector('#app-quiz-results'), grid=root.querySelector('#app-quiz-result-grid');
  var current=0;
  function showStep(focus) {
    steps.forEach(function(step,i){step.hidden=i!==current;});
    back.hidden=current===0;next.textContent=current===steps.length-1?labels.finish:labels.next;
    progress.textContent=labels.step+' '+(current+1)+' '+labels.of+' '+steps.length;
    error.textContent='';if(focus)steps[current].querySelector('legend').focus();
  }
  function paragraph(text, cls) {var p=document.createElement('p');p.textContent=text;if(cls)p.className=cls;return p;}
  function finish() {
    var answers={};new FormData(form).forEach(function(value,key){answers[key]=value;});
    var matches=appRankQuizProducts(products,answers);grid.replaceChildren();
    matches.forEach(function(p,index) {
      var fit=appQuizFit(p,answers);
      var card=document.createElement('article');card.className='app-quiz-result-card';
      if(p.image){var img=document.createElement('img');img.src=p.image;img.alt=p.alt||p.title;img.width=520;img.height=520;img.loading='lazy';card.appendChild(img);}
      var body=document.createElement('div');body.className='app-quiz-result-body';
      body.appendChild(paragraph(index===0?labels.best:labels.other,'app-quiz-match-label'));
      var title=document.createElement('h3');title.textContent=p.title;body.appendChild(title);
      if(p.price && p.available)body.appendChild(paragraph(labels.from+' '+p.price,'app-quiz-price'));
      var days=String(p.min);if(Number(p.max)>Number(p.min))days+=' '+labels.to+' '+p.max;
      body.appendChild(paragraph(Number(p.max)>0?days+' '+labels.days:labels.unknown));body.appendChild(paragraph(labels[p.seed_type]+' · '+labels[p.space]));
      body.appendChild(paragraph(labels.plan,'app-quiz-plan-heading'));
      var notes=[];
      if(p.fallback)notes.push(labels.fallback_note);
      if(answers.space==='compact' && !fit.spaceGap)notes.push(labels.compact_plan);
      if(fit.spaceGap)notes.push(labels.space_adjust);
      notes.push(Number(p.max)>0?(fit.seasonGap?labels.season_adjust:labels.season_check):labels.unknown);
      if(fit.seedMismatch)notes.push(labels.type_adjust);
      if(fit.useMismatch)notes.push(labels.use_adjust);
      if(fit.borerMismatch)notes.push(labels.borer_adjust);
      if(!p.available)notes.push(labels.sold_out);
      var list=document.createElement('ul');list.className='app-quiz-plan';
      notes.forEach(function(note){var item=document.createElement('li');item.textContent=note;list.appendChild(item);});body.appendChild(list);
      var link=document.createElement('a');link.href=p.url+'?app_ref=seed_quiz';link.textContent=p.available?labels.view:labels.check;body.appendChild(link);
      card.appendChild(body);grid.appendChild(card);
    });
    root.querySelector('#app-quiz-result-note').textContent=matches.some(function(p){return p.available;})?labels.matches:labels.stock;
    form.hidden=true;progress.hidden=true;results.hidden=false;results.querySelector('h2').focus();
  }
  form.addEventListener('submit',function(event){event.preventDefault();if(!steps[current].querySelector('input:checked')){error.textContent=labels.select;steps[current].querySelector('input').focus();return;}if(current<steps.length-1){current++;showStep(true);}else finish();});
  back.addEventListener('click',function(){if(current>0){current--;showStep(true);}});
  root.querySelector('#app-quiz-restart').addEventListener('click',function(){form.reset();current=0;results.hidden=true;form.hidden=false;progress.hidden=false;showStep(true);});
  root.querySelector('.app-quiz-actions').hidden=false;showStep(false);
})();

  } catch(e) { console.error(e); }
})();
})();
